<script setup lang="ts">
import { useStore } from '@/store/store'
const store = useStore()
store.commit('setPageTitle', 'Gestion des tâches')
</script>

<template>
  <q-page flex> Tâches </q-page>
</template>
